import React, { useRef, useEffect, useState, Fragment } from 'react';
import 'aframe';
import '../primitives/hotspot';

import AframeIcon from '../components/AframeIcon';
import AframeTitle from '../components/AframeTitle';
import HotspotModal from '../components/HotspotModal/HotspotModal';
import { buildElementId } from 'utils/buildElementId';

const EmbedHotspot = ({
  hotspotId,
  rotation,
  active,
  showBaseHotspot,
  position,
  showLabel,
  isBeingEdited,
  isDisabled,
  cameraPosition,
  darkMode,
  tourId,
  tourName,
  title,
  aid,
  iconSize,
  hideGlow,
  onClick,
  showHotspotModal,
  embedText,
  icon,
  iconSrc,
}) => {
  const iconButtonRef = useRef();

  const [centerHotspot, setCenterHotspot] = useState(false);
  const useCustomIcon = icon && iconSrc;
  const customIconId = buildElementId('custom-icon', hotspotId);
  const customAssetId = buildElementId('custom-asset', hotspotId);
  const focusId = buildElementId('focus-outline', hotspotId);

  useEffect(() => {
    const iconButton = iconButtonRef?.current;
    const handleOpen = () => {
      onClick(hotspotId, isDisabled);
      setCenterHotspot(true);
    };

    iconButton?.addEventListener('click', handleOpen);

    return () => {
      iconButton?.removeEventListener('click', handleOpen);
    };
  }, [onClick, isDisabled, hotspotId, setCenterHotspot]);

  const contentId = `content_${hotspotId}`;
  const iconId = `icon_${hotspotId}`;
  const rigId = `rig_${hotspotId}`;
  const titleId = showLabel ? `title_${hotspotId}` : null;

  return (
    <Fragment>
      <a-entity id={rigId} rotation={rotation}>
        <a-hotspot
          active={active && showBaseHotspot}
          position={position}
          content={contentId}
          underedits={isBeingEdited}
          disabled={isDisabled}
          icon={useCustomIcon ? customIconId : iconId}
          title={titleId}
          id={`hotspot_${hotspotId}`}
          rotateto={cameraPosition}
          translatecontent="0 3.4 0.4"
          type="embed"
          darkmode={darkMode}
          tourId={tourId}
          tourName={tourName}
          hotspotName={title}
          aid={aid}
          data-testid={`hotspot_${hotspotId}`}
          centerHotspot={centerHotspot}
          focusoutlineicon={focusId}
        >
          {showLabel && (
            <AframeTitle
              id={titleId}
              title={title}
              darkMode={darkMode}
              iconSize={iconSize}
              data-testid={titleId}
            />
          )}
          <AframeIcon
            focusId={focusId}
            forwardRef={iconButtonRef}
            src={
              useCustomIcon
                ? `#${customAssetId}`
                : `#hotspot__embed-icon${darkMode ? '-black' : ''}`
            }
            id={useCustomIcon ? customIconId : iconId}
            darkMode={darkMode}
            hideGlow={hideGlow}
            iconSize={iconSize}
            data-testid={useCustomIcon ? customIconId : iconId}
            iconId={useCustomIcon ? customIconId : iconId}
          />
        </a-hotspot>
        {useCustomIcon && (
          <a-asset>
            <img
              src={iconSrc}
              id={customAssetId}
              crossOrigin="anonymous"
              alt=""
            />
          </a-asset>
        )}
      </a-entity>
      <HotspotModal
        name={title}
        hotspotName={title}
        closeModal={() => {
          onClick(hotspotId, isDisabled);
          setCenterHotspot(false);
        }}
        showModal={active && !showBaseHotspot}
        hotspotId={hotspotId}
        type="embed"
        isBeingEdited={isBeingEdited}
        content={embedText}
      />
    </Fragment>
  );
};

export default EmbedHotspot;
